export default __webpack_public_path__ + "static/media/AdGuard.f2576f45.svg";